import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import { useForm } from "react-hook-form"; // Import useForm from react-hook-form

import Addunits from "../../core/modals/inventory/addunits";
import AddCategory from "../../core/modals/inventory/addcategory";
import AddBrand from "../../core/modals/addbrand";
import { GetRequest, PatchRequest } from "../../Api/ApiFunctions";
import { ApiUrl, ConfUrl } from "../../Api/EndPoints";

import {
  ConfImageUploadService,
  flattenObject,
  ImageDataModalRequired,
  transformObject,
} from "./constants";
// import TextArea from "./Components/TextArea";
import MultipleImage from "./Components/MultipleImage";
import TextArea from "./Components/TextArea";

const Turnkey = () => {
  const route = all_routes;
  const [banner, setBanner] = useState([]);
  const [turnkey, setTurnkey] = useState([]);

  // const [Res, setRes] = useState("");
  const navigate = useNavigate();
  const {
    // register,
    handleSubmit,
    setValue,
    control,
    formState: { isSubmitting },
  } = useForm();

  const fetchData = async () => {
    const res = await GetRequest(`${ApiUrl.configuration}${ConfUrl.turkey}`);
    if (res) {
      setBanner([res?.value?.banner]);
      setTurnkey([res?.value?.turnkey]);
      const val = flattenObject(res?.value, "", ["banner", "turnkey"]);
      Object.keys(val).forEach((key) => {
        setValue(key, val[key]);
      });

      setValue("confId", res.id);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = async (data) => {
    let Req = transformObject(data);

    if (banner?.length > 0) {
      let imgKey = null;
      if (banner[0]?.image instanceof File) {
        imgKey = await ConfImageUploadService(banner[0]?.image);
      }
      Req.banner = {
        key: banner[0]?.key,
        image: imgKey ? imgKey : banner[0]?.image,
        heading: banner[0]?.heading,
        subHeading: banner[0]?.subHeading,
      };
    }
    if (turnkey?.length > 0) {
      let imgKey = null;
      if (turnkey[0]?.image instanceof File) {
        imgKey = await ConfImageUploadService(turnkey[0]?.image);
      }
      Req.turnkey = {
        key: turnkey[0]?.key,
        image: imgKey ? imgKey : turnkey[0]?.image,
        heading: turnkey[0]?.heading,
        subHeading: turnkey[0]?.subHeading,
      };
    }

    const resp = await PatchRequest(
      `${ApiUrl.configuration}${ConfUrl.turkey}`,
      Req
    );
    if (resp) {
      navigate(route.jobapplication);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Turnkey Solutions</h4>
              {/* <h6>Create new Career</h6> */}
            </div>
          </div>
        </div>
        {/* /add */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div className="row">
                <h4>
                  <u>Banner</u>
                </h4>
                <div className="col-12">
                  <MultipleImage
                    id="banner"
                    dataSource={banner}
                    setDataSource={setBanner}
                    DataRequired={[
                      ImageDataModalRequired.image,
                      ImageDataModalRequired.heading,
                      ImageDataModalRequired.description,
                    ]}
                    DataLimit={1}
                  />
                </div>
                <div className="col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Section 1</label>
                    <TextArea
                      control={control}
                      id="section1"
                      placeholder="Section content"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Section 2</label>
                    <TextArea
                      control={control}
                      id="section2"
                      placeholder="Section content"
                    />
                  </div>
                </div>

                <h4>
                  <u>Unrivalled Quality</u>
                </h4>
                <div className="col-12">
                  <MultipleImage
                    id="turnkey"
                    dataSource={turnkey}
                    setDataSource={setTurnkey}
                    DataRequired={[
                      ImageDataModalRequired.image,
                      ImageDataModalRequired.heading,
                      ImageDataModalRequired.description,
                    ]}
                    DataLimit={1}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="btn-addproduct mb-4">
              <button type="button" className="btn btn-cancel me-2">
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-submit"
                // disabled={isSubmitting}
                // onClick={() => console.log("trapped")}
              >
                {isSubmitting ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </form>
        {/* /add */}
      </div>
      <Addunits />
      <AddCategory />
      <AddBrand />
    </div>
  );
};

export default Turnkey;
